module.exports = __webpack_public_path__ + "assets/PTM55F_W.e898c7140d9688da982be5335564a60ff544ad0f7e0d4b7001cc5b3b4802a581.woff2";